module.exports = __webpack_public_path__ + "img/rbsistemawelfare-logo.c89a4824.png";